<template>
  <div style="display: flex; flex-wrap: wrap">
    <div v-for="(dItem, dIndex) in dataList" :key="dIndex">
      <!-- <div class="boxTitle">{{dIndex+1}}</div> -->
      <div style="display: flex; margin-top: 20px">
        <div class="contentBoxSmall">
          <div>{{ dItem.name }}</div>
          <div style="display: flex; align-items: center">
            <div class="contentText">{{ dItem.value }}</div>
            <div
              v-if="type == 'process'"
              @click="toProcess(dItem.key)"
              style="
                color: #409eff;
                text-decoration: underline;
                font-size: 10px;
                cursor: pointer;
                margin-left: 10px;
              "
            >
              去处理
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import myTable from "@/common/m-table.vue";

export default {
  data() {
    return {};
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
    },
  },
  created() {
    // this.sceneLoading = this.$loading({
    //   lock: true,
    //   text: "请稍等",
    //   spinner: "el-icon-loading",
    //   background: "rgba(0, 0, 0, 0.7)",
    // });
    // this.getSceneData(1);
  },
  // components: {
  //   myTable,
  // },
  methods: {
    toProcess(name) {
      this.$emit("toProcess", name);
    },
  },
};
</script>

<style scoped>
.contentBoxBig {
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  line-height: 2rem;
  border: 1px solid #eee;
  width: 170px;
  height: 100px;
  margin-right: 15px;
  border-radius: 5px;
  font-size: 12px;
}
.contentBoxSmall {
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  line-height: 2rem;
  border: 1px solid #eee;
  width: 140px;
  height: 80px;
  margin-right: 10px;
  border-radius: 5px;
  font-size: 10px;
}
.sumaryTitle > span {
  font-size: 17px;
  font-weight: bold;
}
.contentText {
  font-size: 18px;
  font-weight: bold;
}
.indexBox {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 16px;
  background-color: #fff;
  background-image: none;
  box-sizing: border-box;
  color: #606266;
}
.fliterTitle {
  display: inline-block;
  margin-left: 50px;
}
.contentBox {
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  line-height: 2rem;
  border: 1px solid #eee;
  width: 150px;
  height: 80px;
  margin: 0 15px;
  border-radius: 5px;
  font-size: 12px;
}
.boxTitle {
  padding: 20px 0 10px 10px;
  color: #4a4a4a;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  font-size: 14px;
  font-weight: bold;
  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu,
    Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
}
.edit-modal-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--sm);
}

.edit-modal-item span {
  display: inline-block;
  min-width: 6em;
  text-align: right;
}
.selectTag {
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
  padding: 0 8px;
  font-size: 14px;
  cursor: pointer;
}
.onSelectTag {
  border: 1px solid #409eff;
  color: #409eff;
}
.detailBroken {
  color: #48a2ff;
  border-bottom: 1px solid #48a2ff;
  font-weight: 500;
  cursor: pointer;
  font-size: 12px;
}
.cashBtn {
  background: rgb(103, 194, 58);
  border-radius: 5px;
  color: rgb(255, 255, 255);
  width: 40px;
  height: 20px;
  font-size: 10px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}

.uploader {
  width: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.uploader.sub {
  width: 65px;
}

.uploader:hover {
  border-color: #409eff;
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  line-height: 150px;
  text-align: center;
}

.uploader-icon.sub {
  width: 65px;
  line-height: 65px;
}
.cashBtn {
  background: rgb(103, 194, 58);
  border-radius: 5px;
  color: rgb(255, 255, 255);
  width: 40px;
  height: 20px;
  font-size: 10px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/zzcbpmDashboard/common/myScene.vue